import React from "react";
import { Equipment } from "../models/EquipmentTypes";

interface EquipmentTableProps {
  equipment: Equipment[];
  onSelect: (eq: Equipment) => void;
}

const EquipmentTable: React.FC<EquipmentTableProps> = ({ equipment, onSelect }) => {
  if (equipment.length === 0) {
    return (
      <div className="ee-table-container">
        <div className="ee-empty">No equipment found</div>
      </div>
    );
  }

  return (
    <div className="ee-table-container">
      <table className="ee-table">
        <thead>
          <tr>
            <th>Controller ID</th>
            <th>Equipment Name</th>
            <th>Location</th>
            <th>Country</th>
            <th>Business Unit</th>
            <th>Product Family</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {equipment.map((eq, idx) => (
            <tr key={`${eq.equipment_id}-${idx}`} onClick={() => onSelect(eq)}>
              <td className="ee-controller">{eq.equipment_controller_id || "-"}</td>
              <td className="ee-name">{eq.equipment_name || eq.equipment_serial_number || eq.equipment_id}</td>
              <td>{eq.location_name || "-"}</td>
              <td>{eq.location_country_code || "-"}</td>
              <td>{eq.business_unit || "-"}</td>
              <td>{eq.product_family_name || "-"}</td>
              <td>
                <span className={`ee-status ee-status-${eq.functional_object_status === 'customfo' ? 'customfo' : eq.functional_object_status}`}>
                  {eq.functional_object_status || "-"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EquipmentTable;